/**
 * @generated SignedSource<<59c65952d0bd9775965ecf53341f1f05>>
 * @relayHash 6b6fec00eda2ea51a57ac57818ecf635
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d8b5a18c360bba4732b979fd38981a1f5ba6349cbbf9fd90845ae0e5a8631ae7

import type { ConcreteRequest } from 'relay-runtime';
export type CommentAgentSessionsQuery$variables = {
  pageId: string;
};
export type CommentAgentSessionsQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly allCommentAgentSessions: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly agentSession: {
              readonly state: string | null;
            } | null;
            readonly conversationId: string | null;
            readonly subEntityId: string | null;
          } | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type CommentAgentSessionsQuery = {
  response: CommentAgentSessionsQuery$data;
  variables: CommentAgentSessionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "pageId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "conversationId"
},
v4 = {
  "kind": "ScalarField",
  "name": "subEntityId"
},
v5 = {
  "kind": "ScalarField",
  "name": "state"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentAgentSessionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "AgentSessionAssociationConnection",
                "kind": "LinkedField",
                "name": "allCommentAgentSessions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AgentSessionAssociationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AgentSessionAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "AgentSession",
                            "kind": "LinkedField",
                            "name": "agentSession",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentAgentSessionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "AgentSessionAssociationConnection",
                "kind": "LinkedField",
                "name": "allCommentAgentSessions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AgentSessionAssociationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AgentSessionAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "AgentSession",
                            "kind": "LinkedField",
                            "name": "agentSession",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v2/*: any*/)
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6b6fec00eda2ea51a57ac57818ecf635",
    "id": "d8b5a18c360bba4732b979fd38981a1f5ba6349cbbf9fd90845ae0e5a8631ae7",
    "metadata": {},
    "name": "CommentAgentSessionsQuery",
    "operationKind": "query",
    "text": "query CommentAgentSessionsQuery($pageId:ID!){content(id:$pageId){nodes{id,allCommentAgentSessions{edges{node{conversationId,subEntityId,agentSession{state,id},id}}}}}}"
  }
};
})();

(node as any).hash = "68a2d0c38664a475a6c59304de7bf457";

export default node;
